export default __webpack_public_path__ + "static/media/book_placeholder.da38bb9c.png";